interface VideoPlayerProps {
  src: string;
}

export function VideoPlayer({ src }: VideoPlayerProps) {
  return (
    <video
      key={src}
      controls
      autoPlay
      muted
      loop
      playsInline
      className="w-full rounded-kiosk bg-black"
    >
      <source src={src} />
    </video>
  );
}
